import { ISimpleSelectItem } from '../../../components/select/SimpleSelect';
import { Country, TrailerType } from 'src/types/enums';
import { COUNTRY_VALUES } from '../../../utils/address';
import type { ExtractedLane } from '../endpoints/ExtractLanesEndpoint.types';

export interface ILineState {
  departure?: [number, number];
  arrival?: [number, number];
  fetchKey?: string;
}

export interface IQuotationLineValues {
  departurePostalCode: string;
  departureCountry: ISimpleSelectItem;
  departureCity: string;
  arrivalPostalCode: string;
  arrivalCountry: ISimpleSelectItem;
  arrivalCity: string;
  distance: string;
  price: string;
  trailerTypes: TrailerType[];
}

export const initialLineValues: IQuotationLineValues = {
  departurePostalCode: '',
  departureCountry: COUNTRY_VALUES.find((v) => v.key === Country.Be)!,
  departureCity: '',
  arrivalPostalCode: '',
  arrivalCountry: COUNTRY_VALUES.find((v) => v.key === Country.Be)!,
  arrivalCity: '',
  distance: '',
  price: '',
  trailerTypes: [TrailerType.Tautliner],
};

export function mapExtractedLaneToValues(lane: ExtractedLane): IQuotationLineValues {
  const departureCountry = COUNTRY_VALUES.find((v) => v.key === lane.departureCountry);
  const arrivalCountry = COUNTRY_VALUES.find((v) => v.key === lane.arrivalCountry);

  return {
    departurePostalCode: lane.departurePostalCode,
    departureCountry: departureCountry ?? initialLineValues.departureCountry,
    departureCity: lane.departureCity,
    arrivalPostalCode: lane.arrivalPostalCode,
    arrivalCountry: arrivalCountry ?? initialLineValues.arrivalCountry,
    arrivalCity: lane.arrivalCity,
    distance: lane.distance != null ? lane.distance.toFixed(2) : '',
    price: lane.price != null ? lane.price.toFixed(2) : '',
    trailerTypes:
      lane.trailerTypes.length > 0
        ? (lane.trailerTypes.filter((t) => Object.values(TrailerType).includes(t as TrailerType)) as TrailerType[])
        : [TrailerType.Tautliner],
  };
}
